/**
 * Norsk → English. Bygget av `npm run i18n`.
 *
 * Nøkkelen er den norske teksten slik den står i koden. Verdier kan rettes
 * for hånd - skriptet oversetter kun tekster som mangler, og rører aldri en
 * verdi som allerede står her. Fila skrives om i sin helhet ved hver kjøring,
 * så egne kommentarer inni lista forsvinner.
 */
export const name = 'English'

export const strings = {
  '-knappen nederst': ' button at the bottom',
  '{amount} er lagt til sparegrisen din.': '{amount} has been added to your piggy bank.',
  '{amount} er trukket fra. Du har {balance} igjen.':
    '{amount} has been deducted. You have {balance} left.',
  '{amount1} venter på godkjenning — du har {amount2} å bruke av':
    '{amount1} awaiting approval — you have {amount2} to spend',
  '{count} ganger': '{count} times',
  '{count} ganger per dag': '{count} times per day',
  '{count} ganger per uke': '{count} times per week',
  '{days} {unit} igjen': '{days} {unit} left',
  '{n} denne uka': '{n} this week',
  '{n} kjøp': '{n} purchases',
  '{n} stjerner': '{n} stars',
  '{n} totalt': '{n} total',
  '{stars} stjerner på {count} ganger': '{stars} stars over {count} times',
  '{stars} stjerner totalt': '{stars} stars total',
  '{used}/{limit} brukt': '{used}/{limit} used',
  '1 gang per dag': '1 time per day',
  '1 gang per uke': '1 time per week',
  '1 stjerne = {sum}': '1 star = {sum}',
  'Aldri': 'Never',
  'Alle': 'All',
  'Alle barna': 'All children',
  'Alle bidrar mot samme tall. Ingen taper.':
    'Everyone contributes to the same number. No one loses.',
  'Alltid': 'Always',
  'alt lagres kun i denne nettleseren.': 'everything is stored only in this browser.',
  'Alt på plass, gulvet fritt': 'Everything away, floor clear',
  'Alt som har gått inn og ut.': "Everything that's come in and gone out.",
  'Angre': 'Undo',
  'Angre utbetaling': 'Undo payout',
  'Angre utbetalingen? Beløpet trekkes fra saldoen igjen.':
    'Undo the payout? The amount will be deducted from the balance again.',
  'Annet': 'Other',
  'Antall stjerner familien skal samle til sammen.':
    'How many stars the family should collect in total.',
  'automatisk': 'automatic',
  'Avbryt': 'Cancel',
  'Avslutt': 'Exit',
  'Avvis': 'Reject',
  'Avvist': 'Rejected',
  'Bare nysgjerrig?': 'Just curious?',
  'Bare over et beløp': 'Only above an amount',
  'Barn': 'Children',
  'Barna': 'The children',
  'Barnas lommepengekonto — der de lærer å tjene, spare og bruke egne penger. Med gjøremål, stjerner og oversikt for hele familien.':
    "The kids' pocket money account — where they learn to earn, save and spend their own money. With chores, stars and an overview for the whole family.",
  'barnet': 'the child',
  'Barnet bruker denne sammen med familiekoden.':
    'The child uses this together with the family code.',
  'Barnet deltar ikke i denne utfordringen': "This child isn't taking part in this challenge",
  'Barnet fører opp hva det har brukt og på hva, og ser sin egen forbruksoversikt. Ingen kan føre seg under null.':
    "The child logs what they've spent and on what, and sees their own spending overview. No one can go below zero.",
  'Barnet må ha et navn': 'The child needs a name',
  'Beløp ({currency})': 'Amount ({currency})',
  'Beløpet kan ikke være null': 'The amount cannot be zero',
  'Beløpet legges til saldoen.': 'The amount is added to the balance.',
  'Beløpet trekkes fra saldoen. Skriv det positivt.':
    'The amount is subtracted from the balance. Enter it as a positive number.',
  'Beskrivelse': 'Description',
  'Beskrivelse (valgfritt)': 'Description (optional)',
  'Betalingsgrensen er brukt opp. Stjernene føres som vanlig, men uten penger.':
    'The payout cap is used up. The stars are logged as usual, but without money.',
  'Bla ned og velg': 'Scroll down and choose',
  'Bli med': 'Join',
  'Bok eller tegneserie teller': 'A book or a comic counts',
  'Bra jobba!': 'Well done!',
  'Bruk minus for å trekke fra, f.eks. -50.': 'Use minus to subtract, e.g. -50.',
  'Bruk oppgavelista for oppgaver': 'Use the chore list for chores',
  'Brukeren mangler innlogging': 'This user has no login',
  'Brukt denne måneden': 'Spent this month',
  'Brukt penger': 'Money spent',
  'Brukt til sammen': 'Spent in total',
  'Bursdagspenger fra bestemor': 'Birthday money from Grandma',
  'Bytt familie': 'Switch family',
  'Bøker': 'Books',
  'Da har du {amount} igjen.': "Then you'll have {amount} left.",
  'Da åpnes den som en vanlig app, uten nettleserlinje.':
    'It then opens like a regular app, without the browser bar.',
  'dag': 'day',
  'dager': 'days',
  'data lagres kun i denne nettleseren': 'data is stored only in this browser',
  'deg': 'you',
  'Dekke bordet': 'Set the table',
  'Del': 'Share',
  'Del denne koden med den andre forelderen:': 'Share this code with the other parent:',
  'Demomodus': 'Demo mode',
  'Den {day}.': 'Day {day}',
  'Denne er allerede behandlet': 'This one has already been handled',
  'Denne må godkjennes av en voksen først.': 'This needs to be approved by an adult first.',
  'Denne måneden': 'This month',
  'Denne oppgaven er tildelt noen andre': 'This chore belongs to someone else',
  'denne uka': 'this week',
  'Det finnes allerede en konto med denne e-posten': 'An account with this email already exists',
  'Dette angrer kjøpet barnet førte opp. Fortsette?':
    'This undoes the purchase the child logged. Continue?',
  'Dette angrer også oppgaven barnet registrerte. Fortsette?':
    'This also undoes the chore the child checked off. Continue?',
  'Dette er allerede behandlet': 'This has already been handled',
  'Dette må en voksen godkjenne først.': 'This must be approved by an adult first.',
  'Ditt navn': 'Your name',
  'Du er allerede med i en familie': "You're already in a family",
  'Du er logget inn via lenka i e-posten.': "You're signed in via the link in the email.",
  'Du er på {place}. plass': "You're in {place} place",
  'Du har': 'You have',
  'Du har alt fått penger for denne {limit} ganger {when}. Den teller fortsatt, og gir stjerner.':
    "You've already been paid for this one {limit} times {when}. It still counts, and still gives stars.",
  'Du har ikke brukt noe ennå.': "You haven't spent anything yet.",
  'Du har ikke så mye igjen': "You don't have that much left",
  'Du kan fortsatt angre en føring i kontoutskriften.':
    'You can still undo an entry in the statement.',
  'Du leder — delt førsteplass!': "You're leading — tied for first place!",
  'Du leder!': "You're leading!",
  'E-post': 'Email',
  'En voksen kan lage en — for eksempel en lesekonkurranse.':
    'An adult can create one — for example a reading contest.',
  'Endre': 'Edit',
  'Endre →': 'Edit →',
  'Endre barn': 'Edit child',
  'Endre kategori': 'Edit category',
  'Endre oppgave': 'Edit chore',
  'Endre postering': 'Edit entry',
  'Endre utfordring': 'Edit challenge',
  'Endrer bare pengene. Stjernene barnet fikk står som de er.':
    'Only changes the money. The stars the child earned stay as they are.',
  'Endringen gjelder framover. Allerede godkjente oppgaver beholder sin verdi.':
    'The change applies going forward. Already-approved chores keep their value.',
  'Er den av, går stjernene rett inn på saldoen når barnet huker av.':
    "When it's off, the stars go straight to the balance when the child checks it off.",
  'Et felles mål må ha et måltall': 'A shared goal needs a target number',
  'Etterpå oppretter du en ny familie, eller blir med i en du har fått invitasjonskode til.':
    'Next you create a new family, or join one you have an invitation code for.',
  'F.eks. «gjort mens mobilen lå til lading»': 'E.g. «done while the phone was charging»',
  'F.eks. «hvem leser mest fram til jul», et felles mål familien jobber mot, eller et personlig mål for hvert barn.':
    'E.g. «who reads the most before Christmas», a shared goal the family works towards, or a personal goal for each child.',
  'F.eks. «tok også under senga»': 'E.g. «also did under the bed»',
  'F.eks. ukelønn eller gave.': 'E.g. allowance or a gift.',
  'Familie': 'Family',
  'Familiekode — barna bruker denne for å logge inn': 'Family code — children use this to log in',
  'Familien': 'The Family',
  'Familienavn': 'Family name',
  'Fant ikke barnet': "Couldn't find that child",
  'Fant ikke oppgaven': "Couldn't find that chore",
  'Fant ikke posteringen': 'Could not find the entry',
  'Fant ikke registreringen': "Couldn't find that entry",
  'Fant ikke utfordringen': "Couldn't find the challenge",
  'Fant ikke uttaket': "Couldn't find the withdrawal",
  'Fant ingen familie med den koden': 'No family found with that code',
  'Fant ingen språk som matcher søket.': 'Found no languages matching the search.',
  'Fant ingen utbetaling å angre': "Couldn't find a payout to undo",
  'Farge': 'Color',
  'Farge {color}': 'Color {color}',
  'Fast beløp': 'Fixed amount',
  'Fast lommepenger': 'Regular allowance',
  'Fast lommepenger som ble satt inn automatisk.':
    'Regular allowance that was paid in automatically.',
  'Faste lommepenger må være mer enn null': 'A regular allowance must be more than zero',
  'Feil e-post eller passord': 'Incorrect email or password',
  'Feil PIN-kode': 'Wrong PIN',
  'Felles mål': 'Shared goal',
  'Felles måltall': 'Shared target',
  'Ferdig': 'Finished',
  'Ferdige': 'Finished',
  'Figur': 'Character',
  'for {count} min siden': '{count} min ago',
  'for {count} t siden': '{count} h ago',
  'For foreldre': 'For parents',
  'Forelder': 'Parent',
  'Foreldrene dine har slått av at du kan føre opp kjøp selv':
    'Your parents have turned off letting you log purchases yourself',
  'Fortsett': 'Continue',
  'Fra': 'From',
  'Fredag': 'Friday',
  'Fritt opp til ({currency})': 'Free up to ({currency})',
  'Følger stjernekursen': 'Follows the star rate',
  'Før opp kjøpet': 'Log the purchase',
  'Føres som godkjent med én gang.': 'Logged as approved right away.',
  'Ført opp!': 'Logged!',
  'Gangene utover dette gir stjerner, men ingen penger. Nyttig i utfordringer, der alt barnet gjør skal telle.':
    'Times beyond this give stars, but no money. Handy in challenges, where everything the child does should count.',
  'Gave til noen': 'A gift for someone',
  'Gir': 'Gives',
  'gir bare stjerner nå': 'only gives stars now',
  'gir ingen stjerner': 'gives no stars',
  'Gjøremål': 'Chores',
  'Gjøremålet er registrert': 'Chore checked off',
  'Glemt passord?': 'Forgot password?',
  'Godkjenn': 'Approve',
  'Godkjent': 'Approved',
  'Godteri': 'Sweets',
  'Går ikke lenger enn den 28., slik at februar aldri hopper over en utbetaling.':
    'Stops at the 28th, so February never skips a payment.',
  'Har du allerede konto?': 'Already have an account?',
  'Har du ikke konto?': "Don't have an account?",
  'Har invitasjon': 'Have an invitation',
  'Hei, {name}!': 'Hi, {name}!',
  'Hei!': 'Hi!',
  'Hele appen vises på dette språket for hele familien':
    'The whole app is shown in this language for the whole family',
  'Hele tiden': 'All time',
  'Historikk': 'History',
  'Hjemme': 'Home',
  'Hva er én stjerne verdt? ({currency})': 'What is one star worth? ({currency})',
  'Hva gikk pengene til?': 'What was the money spent on?',
  'Hva kjøpte du? (valgfritt)': 'What did you buy? (optional)',
  'Hva skal gjøres?': 'What needs to be done?',
  'Hvem er du?': 'Who are you?',
  'Hvem er med?': "Who's taking part?",
  'Hvem kan gjøre den?': 'Who can do it?',
  'Hvem leser mest?': 'Who reads the most?',
  'Hver gang': 'Every time',
  'Hver måned': 'Every month',
  'Hver uke': 'Every week',
  'Hvert barn får sitt eget tall, og rangeres på hvor langt de er kommet mot sitt. Jevner ut aldersforskjeller.':
    "Each child gets their own number, and is ranked by how far they've come towards it. Evens out age differences.",
  'Hvilke oppgaver teller?': 'Which chores count?',
  'Hvilken dag?': 'Which day?',
  'Hvilken dato?': 'Which date?',
  'Hvor mye brukte du?': 'How much did you spend?',
  'Hvor ofte gir den penger?': 'How often does it pay?',
  'Hvor ofte kan den gjøres?': 'How often can it be done?',
  'i dag': 'today',
  'I dag {time}': 'Today {time}',
  'I går {time}': 'Yesterday {time}',
  'Ikke innlogget': 'Not logged in',
  'Ikke nå': 'Not now',
  'Ikon': 'Icon',
  'Ingen': 'None',
  'Ingen barn er lagt til ennå.': 'No children added yet.',
  'Ingen barn er lagt til i denne familien ennå.':
    'No children have been added to this family yet.',
  'Ingen barn lagt til ennå.': 'No children added yet.',
  'Ingen gjøremål her ennå.': 'No chores here yet.',
  'Ingen gjøremål registrert ennå. Trykk på knappen over for å komme i gang!':
    'No chores checked off yet. Tap the button above to get started!',
  'Ingen gjøremål å velge mellom.': 'No chores to choose from.',
  'Ingen mål': 'No goal',
  'Ingen oppgaver ennå.': 'No chores yet.',
  'Ingen oppgaver her.': 'No chores here.',
  'Ingen posteringer ennå.': 'No entries yet.',
  'Ingen stjerner samlet i perioden — ingen vinner å kåre.':
    'No stars collected in the period — no winner to crown.',
  'Ingen utfordringer akkurat nå.': 'No challenges right now.',
  'Ingen utfordringer ennå.': 'No challenges yet.',
  'Ingenting har skjedd ennå.': 'Nothing has happened yet.',
  'Innloggingen er ikke gyldig lenger. Logg ut og inn på nytt.':
    'Your login has expired. Log out and back in.',
  'Innskudd': 'Deposit',
  'Innstillinger': 'Settings',
  'Installer': 'Install',
  'Invitasjonskode': 'Invitation code',
  'Inviter med-forelder': 'Invite co-parent',
  'Is på butikken': 'Ice cream at the shop',
  'Ja, barna kan trekke fra selv': 'Yes, children can deduct on their own',
  'Ja, jeg har gjort det!': 'Yes, I did it!',
  'Jeg er barn': "I'm a child",
  'Jeg er forelder': "I'm a parent",
  'Jeg har brukt penger': "I've spent money",
  'Kan barna føre opp egne kjøp?': 'Can children log their own purchases?',
  'Kategori': 'Category',
  'Kategorien trenger et navn': 'The category needs a name',
  'Kiosk på fotballcup': 'Snack bar at the football cup',
  'Kjøkken': 'Kitchen',
  'Kjøp over dette beløpet havner til godkjenning hos deg.':
    'Purchases above this amount go to you for approval.',
  'Kjøp til godkjenning ({count})': 'Purchases to approve ({count})',
  'Klarte ikke å hente historikken.': 'Could not load the history.',
  'Klarte ikke å hente kontoutskriften.': 'Could not load the statement.',
  'Klarte ikke å logge inn. Prøv igjen.': "Couldn't log in. Try again.",
  'Klær': 'Clothes',
  'Kommer av seg selv, i tillegg til det barnet tjener på gjøremål.':
    'Arrives on its own, on top of what the child earns from chores.',
  'Konkurranser og mål du er med i.': "Contests and goals you're part of.",
  'Konkurranser og mål over tid': 'Contests and goals over time',
  'Kontoutskrift': 'Statement',
  'Kopier': 'Copy',
  'Kopiert': 'Copied',
  'Korriger': 'Adjust',
  'Korriger saldo': 'Correct balance',
  'Korrigering': 'Correction',
  'krever godkjenning': 'requires approval',
  'Krever godkjenning': 'Requires approval',
  'kun': 'only',
  'Kun': 'Only',
  'Kun barn bruker denne': 'Only children use this',
  'Kun barn kan registrere oppgaver': 'Only children can log chores',
  'Kun foreldre kan angre': 'Only parents can undo',
  'Kun foreldre kan angre utbetaling': 'Only parents can undo a payout',
  'Kun foreldre kan endre beløp': 'Only parents can change amounts',
  'Kun foreldre kan endre posteringer': 'Only parents can change entries',
  'Kun foreldre kan endre saldo': 'Only parents can change the balance',
  'Kun foreldre kan gjøre dette': 'Only parents can do this',
  'Kun foreldre kan godkjenne': 'Only parents can approve',
  'Kun foreldre kan invitere': 'Only parents can invite',
  'Kun foreldre kan lage utfordringer': 'Only parents can create challenges',
  'Kun foreldre kan registrere for et barn': 'Only parents can log a chore for a child',
  'Kun foreldre kan sette lommepenger': 'Only parents can set the allowance',
  'Kun foreldre kan slette': 'Only parents can delete',
  'Kun foreldre kan slette utfordringer': 'Only parents can delete challenges',
  'Kun foreldre kan utbetale premie': 'Only parents can pay out the prize',
  'Kunne ikke kopiere': "Couldn't copy",
  'Lag den første': 'Create the first one',
  'Lagre': 'Save',
  'Lagret': 'Saved',
  'Lagret!': 'Saved!',
  'Lar du feltet stå tomt, vises hva slags postering det er.':
    'Leave it empty to show what kind of entry it is.',
  'Leder': 'Leader',
  'Legg Bonto på hjemskjermen': 'Add Bonto to your home screen',
  'Legg til': 'Add',
  'Legg til barn': 'Add child',
  'Legg til barn i familien først.': 'Add a child to the family first.',
  'Legg til på Hjem-skjerm': 'Add to Home Screen',
  'Leker': 'Toys',
  'Lese 15 minutter': 'Read for 15 minutes',
  'Lesekonkurranse': 'Reading contest',
  'Logg inn': 'Log in',
  'Logg inn som forelder med hva som helst, eller prøv barneinnlogging med familiekode':
    'Log in as a parent with anything, or try the child login with family code',
  'Logg ut': 'Log out',
  'Lommepenger': 'Pocket money',
  'Lukk': 'Close',
  'Lørdag': 'Saturday',
  'Mamma eller pappa må si ok før stjernene blir til penger.':
    'Mom or dad has to say OK before the stars turn into money.',
  'Mandag': 'Monday',
  'Mat og drikke': 'Food and drink',
  'Min profil': 'My profile',
  'Min side': 'My page',
  'Minst 8 tegn': 'At least 8 characters',
  'Må du godkjenne?': 'Do you need to approve?',
  'Mål': 'Goal',
  'Målet ble ikke nådd. Du kan likevel utbetale premien manuelt under.':
    "The goal wasn't reached. You can still pay out the prize manually below.",
  'Målet er nådd!': 'The goal has been reached!',
  'Måltall': 'Target number',
  'Måltallet er hvor mange stjerner barnet skal samle.':
    'The target is how many stars the child should collect.',
  'Månedslønn': 'Monthly allowance',
  'Månedslønn {amount}': 'Monthly allowance {amount}',
  'Navn': 'Name',
  'Navnet ditt og PIN-koden endres av en voksen.':
    'Your name and PIN code are changed by an adult.',
  'neste {date}': 'next {date}',
  'Neste utbetaling {date}': 'Next payment {date}',
  'Nesten ferdig': 'Almost done',
  'Notat (valgfritt)': 'Note (optional)',
  'Ny': 'New',
  'Ny familie': 'New family',
  'Ny familie?': 'New family?',
  'Ny kategori': 'New category',
  'Ny oppgave': 'New chore',
  'Ny utfordring': 'New challenge',
  'Ny versjon klar': 'New version ready',
  'Nytt passord': 'New password',
  'nå nettopp': 'just now',
  'Når barnet har brukt av sparepengene.': 'When the child has spent some of their savings.',
  'og PIN': 'and PIN',
  'Onsdag': 'Wednesday',
  'Oppdater': 'Update',
  'Oppgaven er ikke aktiv': "That chore isn't active",
  'Oppgaven er slettet': 'The chore has been deleted',
  'Oppgaven må gi stjerner eller penger': 'The chore must give stars or money',
  'Oppgaven trenger et navn': 'The chore needs a name',
  'Oppgaver': 'Chores',
  'Opprett en ny familie, eller bli med i en som allerede finnes.':
    'Create a new family, or join one that already exists.',
  'Opprett familie': 'Create family',
  'Opprett konto': 'Create account',
  'Oversikt': 'Overview',
  'Passord': 'Password',
  'Passordet er oppdatert.': 'The password has been updated.',
  'Passordet må ha minst 8 tegn': 'The password must be at least 8 characters',
  'Penger': 'Money',
  'penger {count} ganger per dag': 'money {count} times per day',
  'penger {count} ganger per uke': 'money {count} times per week',
  'penger 1 gang per dag': 'money 1 time per day',
  'penger 1 gang per uke': 'money 1 time per week',
  'Per dag': 'Per day',
  'Per uke': 'Per week',
  'Personlig mål': 'Personal goal',
  'PIN-kode (4 siffer)': 'PIN code (4 digits)',
  'PIN-koden må være 4 siffer': 'The PIN code must be 4 digits',
  'Postering': 'Entry',
  'Posteringen er endret': 'Entry changed',
  'Premie': 'Prize',
  'Premie i {currency} (valgfritt)': 'Prize in {currency} (optional)',
  'premie utbetalt': 'prize paid out',
  'Premien barnet fikk utbetalt.': 'The prize paid out to the child.',
  'Premien er allerede utbetalt til dette barnet':
    'The prize has already been paid out to this child',
  'Premien er utbetalt': 'The prize has been paid out',
  'Prøv demoen': 'Try the demo',
  'Prøv igjen': 'Try again',
  'Pågår': 'In progress',
  'Registrer': 'Check off',
  'Registrer et gjøremål': 'Check off a chore',
  'Registrer for {name}': 'Check off for {name}',
  'Registrer gjøremål': 'Check off a chore',
  'Registrert! Stjernene er dine - penger gir den ikke flere ganger nå.':
    "Checked off! The stars are yours — it won't pay out any more times right now.",
  'Ren konkurranse — den som samler flest stjerner vinner.':
    'Pure competition — whoever collects the most stars wins.',
  'Rydde rommet': 'Tidy your room',
  'Saldo': 'Balance',
  'Saldo etter:': 'Balance after:',
  'Saldo nå': 'Balance now',
  'Saldo oppdatert': 'Balance updated',
  'Se alt →': 'See all →',
  'Sendt inn!': 'Submitted!',
  'Sett inn': 'Deposit',
  'Sett inn penger': 'Add money',
  'Sett ny PIN-kode': 'Set new PIN code',
  'Sist godkjent': 'Last approved',
  'Siste dag!': 'Last day!',
  'Siste registreringer': 'Latest check-ins',
  'Sjekk e-posten din': 'Check your email',
  'Skjul': 'Hide',
  'Skole': 'School',
  'Skriv inn e-postadressen din først': 'Enter your email address first',
  'Skriv inn en valuta': 'Enter a currency',
  'Skriv inn et beløp': 'Enter an amount',
  'Skriv inn familiekoden': 'Enter the family code',
  'Skriv inn familiekoden. Den får du av mamma eller pappa.':
    'Enter the family code. You get it from mom or dad.',
  'Skriv inn hvor mye barnet skal få': 'Enter how much the child should get',
  'Skriv inn hvor mye du brukte': 'Enter how much you spent',
  'Skriv inn navnet': 'Enter the name',
  'Slett barn': 'Delete child',
  'Slett kategori': 'Delete category',
  'Slett oppgave': 'Delete chore',
  'Slett posteringen': 'Delete entry',
  'Slett utfordring': 'Delete challenge',
  'Slette {name}? All historikk forsvinner.': 'Delete {name}? All history will be lost.',
  'Slette denne oppgaven? Historikken beholdes.': 'Delete this chore? The history is kept.',
  'Slette denne posteringen?': 'Delete this entry?',
  'Slette kategorien? Oppgavene beholdes, men mister kategori.':
    'Delete the category? The chores are kept, but lose their category.',
  'Slette utfordringen? Registreringene til barna beholdes.':
    "Delete the challenge? The children's check-ins are kept.",
  'Slettet': 'Deleted',
  'Sluttdatoen må være etter startdatoen': 'The end date must be after the start date',
  'Smågodt': 'Pick and mix sweets',
  'Sparegrisen din': 'Your piggy bank',
  'Spill': 'Games',
  'Språk': 'Language',
  'Starter i dag': 'Starts today',
  'Starter om {days} {unit}': 'Starts in {days} {unit}',
  'Starter snart': 'Starting soon',
  'Startsaldo': 'Opening balance',
  'stjernene fra disse teller i utfordringen': 'the stars from these count in the challenge',
  'Stjernene teller som før i totalen og i utfordringer - men det er dette beløpet som havner på saldoen.':
    'The stars count in the total and in challenges as before - but this is the amount that lands on the balance.',
  'Stjerner': 'Stars',
  'stjerner totalt': 'stars total',
  'Stjerner totalt': 'Stars total',
  'Støvsuge stua': 'Vacuum the living room',
  'Synlig for barna': 'Visible to children',
  'Søk etter språk …': 'Search for a language …',
  'Søndag': 'Sunday',
  'Så ofte man vil': 'As often as you like',
  'Ta ut': 'Withdraw',
  'Ta ut penger': 'Withdraw money',
  'Tast PIN-koden din': 'Enter your PIN code',
  'Til {name}': 'For {name}',
  'til barnet.': 'to the child.',
  'Til innlogging': 'To login',
  'Til og med': 'Through',
  'Tilbake': 'Back',
  'Tirsdag': 'Tuesday',
  'tjent': 'earned',
  'tjent i utfordringen': 'earned in the challenge',
  'Tok også gangen': 'Did the hallway too',
  'Torsdag': 'Thursday',
  'Trykk': 'Tap',
  'Trykk for å oppdatere appen.': 'Tap to update the app.',
  'Trykk på': 'Tap the',
  'Trykk på det du har gjort.': "Tap what you've done.",
  'Trykk på lenka for å fullføre registreringen.': 'Tap the link to complete the registration.',
  'Tømme oppvaskmaskinen': 'Empty the dishwasher',
  'Ugyldig beløpsgrense': 'Invalid amount limit',
  'Ugyldig eller utløpt invitasjonskode': 'Invalid or expired invite code',
  'Ugyldig forespørsel': 'Invalid request',
  'Ugyldig stjerneverdi': 'Invalid star value',
  'Ukelønn': 'Allowance',
  'Ukelønn {amount}': 'Weekly allowance {amount}',
  'Ukjent': 'Unknown',
  'Ukjent bruker': 'Unknown user',
  'Ukjent handling': 'Unknown action',
  'Utbetal {amount}': 'Pay out {amount}',
  'Utbetale {amount} til {name}?': 'Pay out {amount} to {name}?',
  'Utbetales manuelt av deg når utfordringen er over — da kan uavgjort håndteres som dere vil.':
    'Paid out manually by you when the challenge is over — that way ties can be handled however you like.',
  'Utbetalingen er angret': 'The payout has been undone',
  'Uten kategori': 'No category',
  'Utfordring': 'Challenge',
  'Utfordringen har ingen premie': 'The challenge has no prize',
  'Utfordringen trenger et navn': 'The challenge needs a name',
  'Utfordringer': 'Challenges',
  'Uttak': 'Withdrawal',
  'Utvendig og innvendig': 'Outside and inside',
  'valgt': 'selected',
  'Valuta': 'Currency',
  'Vaske bilen': 'Wash the car',
  'Vedkommende oppretter konto og velger «Har invitasjon». Koden varer i 14 dager.':
    'They create an account and choose «Have an invitation». The code lasts 14 days.',
  'velg alle': 'select all',
  'Velg en dag mellom 1 og 28': 'Choose a day between 1 and 28',
  'Velg en ukedag': 'Choose a weekday',
  'Velg minst én oppgave som skal telle': 'Choose at least one chore to count',
  'Velg minst ett barn som skal delta': 'Choose at least one child to take part',
  'Velg nytt passord': 'Choose a new password',
  'Velg språk': 'Choose language',
  'Venter på at en voksen godkjenner.': 'Waiting for an adult to approve.',
  'Venter på godkjenning': 'Awaiting approval',
  'Venter på godkjenning ({count})': 'Awaiting approval ({count})',
  'Vi har sendt deg en e-post med lenke for å velge nytt passord.':
    "We've sent you an email with a link to choose a new password.",
  'Vi har sendt en bekreftelseslenke til': "We've sent a confirmation link to",
  'Vil du logge ut?': 'Do you want to log out?',
  'Vil du skrive noe? (valgfritt)': 'Want to write something? (optional)',
  'Vis': 'Show',
  'Vis meg hvordan': 'Show me how',
  'Vises bak alle beløp i appen, f.eks. kr, SEK, DKK, €, $.':
    'Shown after every amount in the app, e.g. kr, SEK, DKK, €, $.',
  'Voksne': 'Adults',
  'å bruke av.': 'to spend.',
}
